import { render, staticRenderFns } from "./Rex.vue?vue&type=template&id=75c8f206&"
import script from "./Rex.vue?vue&type=script&lang=js&"
export * from "./Rex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports